<div class="dialog-title">
  <mat-icon>lock</mat-icon>
  <h2 mat-dialog-titles >Passwort ändern</h2>

</div>


<mat-dialog-content>
  <form [formGroup]="passwordForm">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Altes Passwort</mat-label>
      <input matInput [type]="hideOldPassword() ? 'password' : 'text'" formControlName="oldPassword" placeholder="Altes Passwort">
      <mat-error *ngIf="passwordForm.get('oldPassword')?.hasError('required')">
        Altes Passwort ist erforderlich
      </mat-error>
      <button mat-icon-button
              matSuffix
              type="button"
              (click)="toggleVisibility(hideOldPassword)"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hideOldPassword()">
        <mat-icon>{{hideOldPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Neues Passwort</mat-label>
      <input matInput [type]="hideNewPassword() ? 'password' : 'text'" formControlName="newPassword" placeholder="Neues Passwort">
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">
        Neues Passwort ist erforderlich
      </mat-error>
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('minlength')">
        Neues Passwort muss min. 8 Zeichen lang sein
      </mat-error>
      <button mat-icon-button
              matSuffix
              type="button"
              (click)="toggleVisibility(hideNewPassword)"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hideNewPassword()">
        <mat-icon>{{hideNewPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Neues Passwort bestätigen</mat-label>
      <input matInput [type]="hideConfirmPassword() ? 'password' : 'text'" formControlName="confirmPassword" placeholder="Neues Passwort bestätigen">
      <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">
        Neues Passwort bestätigen ist erforderlich
      </mat-error>
      <mat-error *ngIf="passwordForm.get('confirmPassword')?.hasError('not_matching')">
        Passwörter stimmen nicht überein
      </mat-error>
      <button mat-icon-button
              matSuffix
              type="button"
              (click)="toggleVisibility(hideConfirmPassword)"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hideConfirmPassword()">
        <mat-icon>{{hideConfirmPassword() ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>
  </form>

  <div class="pw-error" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Abbrechen</button>
  <button mat-raised-button color="primary" [disabled]="!passwordForm.valid || loading"
          (click)="changePassword()">
    <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
    Ändern
  </button>
</mat-dialog-actions>
